__turbopack_context__.v({
  "emphasis": "blended-offer-badge-module-scss-module__C-umWq__emphasis",
  "lifetime-access-link": "blended-offer-badge-module-scss-module__C-umWq__lifetime-access-link",
  "terms-link": "blended-offer-badge-module-scss-module__C-umWq__terms-link",
  "value-prop-badge": "blended-offer-badge-module-scss-module__C-umWq__value-prop-badge",
  "value-prop-icon": "blended-offer-badge-module-scss-module__C-umWq__value-prop-icon",
  "value-prop-text": "blended-offer-badge-module-scss-module__C-umWq__value-prop-text",
});
